/**
 *
 * BackButton
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import qs from 'qs';
import { useSelector } from 'react-redux';
import { makeSelectClientDetails } from 'containers/Main/selectors';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { useHistory, useLocation } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ButtonBase from '@material-ui/core/ButtonBase';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import Link from '@material-ui/core/Link';

const useStyles = makeStyles(theme => ({
  link: {
    textDecoration: 'none',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('600')]: {
      justifyContent: 'center',
    },
  },
  justifyLeft: {
    justifyContent: 'flex-start',
  },
  mobile: {
    justifyContent: 'center',
    marginTop: 10,
    [theme.breakpoints.down('600')]: {
      width: 261,
    },
  },
  bordered: {
    border: '1px solid #E9ECED',
    padding: '10px 15px',
    display: 'flex',
    borderRadius: 2,
  },
  linkText: {
    alignItems: 'center',
    textTransform: 'none',
    color: ({ color }) =>
      color ? theme.palette.text.secondary : theme.palette.primary.contrastText,
    ...theme.typography.overline,
  },
  rightIcon: {
    marginLeft: 10,
    marginBottom: 2,
  },
  icon: {
    height: '0.875em',
    width: '0.875em',
    color: ({ color }) =>
      color ? theme.palette.text.secondary : theme.palette.primary.contrastText,
  },
  backBtn: {
    position: 'absolute',
    left: 0,
    top: '50%',
    transform: 'translateY(-50%)',
  },
  wrapperClass: {
    position: 'relative',
    width: '100%',
    height: 22,
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
    },
  },
  mobileLogoContainer: {
    justifyContent: 'center',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
  logoMobile: {
    [theme.breakpoints.down('sm')]: {
      height: 40,
    },
  },
  logoRoot: {
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
  },
  clientLogo: {
    height: 30,
    [theme.breakpoints.down('sm')]: {
      height: 40,
      marginTop: 10,
    },
  },
}));

function BackButton({ to, label }) {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const clientDetails = useSelector(makeSelectClientDetails());

  const clientLogo = _get(clientDetails, ['logoReverse', 'url']);
  const clientCMLogo = _get(
    clientDetails,
    'crediblemindLogo.url',
    'https://images.ctfassets.net/o6q5esfvflvg/2KcKseXcFamHSzXa3RyIZt/ccd266f8caf7f4df837210c6aa917183/CM_Logo_Original.svg',
  );

  const onClick = () => {
    if (to) history.push(to);
    else {
      const params = qs.parse(location.search.slice(1));
      if (params.redirect) history.push(params.redirect);
      else history.push('/');
    }
  };

  return (
    <Grid item xs={12}>
      <Grid container className={classes.wrapperClass}>
        <div className={classes.backBtn}>
          {_get(clientDetails, 'signIn') !== 'Require' && (
            <ButtonBase
              disableRipple
              className={classes.link}
              onClick={onClick}
            >
              <ChevronLeftIcon className={classes.icon} />
              <Typography className={classes.linkText}>{label}</Typography>
            </ButtonBase>
          )}
        </div>
        <Hidden mdUp>
          <div className={classes.mobileLogoContainer}>
            <Link to="/" className={classes.logoRoot}>
              <img
                src={clientCMLogo}
                alt="CredibleMind"
                className={classes.logoMobile}
              />
            </Link>
            {!_isEmpty(clientDetails) && (
              <Hidden mdUp>
                <img
                  src={clientLogo}
                  alt={clientDetails.name}
                  className={classes.clientLogo}
                />
              </Hidden>
            )}
          </div>
        </Hidden>
      </Grid>
    </Grid>
  );
}

BackButton.propTypes = {
  to: PropTypes.string,
  label: PropTypes.string,
};

export default BackButton;
